import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleRadio',
  props: {
    modelValue: [String, Number], // Поддержка строк и чисел для radio
    value: [String, Number], // Значение конкретной радио-кнопки
    label: {
      type: String,
      default: '',
    }
  },
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props
  
  const emit = __emit
  const { modelValue } = toRefs(props)
  
  function setValue(newValue) {
    emit("update:modelValue", newValue)
  }
  
const __returned__ = { props, emit, modelValue, setValue, toRefs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})